import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyUpgradeIcon = lazy(() => import('./svg-components/upgrade-icon'));

const UpgradeIcon = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyUpgradeIcon {...rest} />
  </Suspense>
);

export default UpgradeIcon;
